import { BaseController } from '../../../common/base/controller';

export class ChartController extends BaseController {
  constructor(controllerService, ticketTableService) {
    'ngInject';
    super({ controllerService, ticketTableService });
  }

  isValueFiltered(value) {
    const result = this.excludedFilters[value.key];
    if (this.ticketTableService.isExplicitFilter(result)) {
      return true;
    }
    return !result;
  }
}
